
export default function useTheme() {
    return document.getElementById('root').getAttribute('theme')
}